import { TrelloMarkdownWrapper } from './TrelloMarkdownWrapper';

export type MarkdownContentType =
  | 'bio'
  | 'checkitems'
  | 'comment'
  | 'description';

export const markdown = new TrelloMarkdownWrapper();
